export default __webpack_public_path__ + "static/arrowBottom-ab5ecaa280cadc177b52f3e6052a5436.svg";